export enum CustomFieldType {
    PlainText,
    DateTime,
    Number,
    Checkbox,
    SetOfOptions,
    WebsiteURL,
    IncrementingNumber,
    FileUpload
}